<script lang="ts">
	import { Avatar as AvatarPrimitive } from 'bits-ui'
	import { cn } from 'tailwind-variants'

	let {
		ref = $bindable(null),
		loadingStatus = $bindable('loading'),
		size = 'default',
		class: className,
		...restProps
	}: AvatarPrimitive.RootProps & {
		size?: 'default' | 'sm' | 'lg'
	} = $props()
</script>

<AvatarPrimitive.Root
	class={cn(
		'after:border-border group/avatar relative flex size-8 shrink-0 rounded-full select-none after:absolute after:inset-0 after:rounded-full after:border after:mix-blend-lighten data-[size=lg]:size-10 data-[size=sm]:size-6',
		className
	)}
	data-size={size}
	data-slot="avatar"
	bind:ref
	bind:loadingStatus
	{...restProps}
/>
